/// <reference path="DOMAttached.js" />

var ToggleQuestionReaderInstance = null;

class ToggleQuestionReader extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.options = options;
		ToggleQuestionReaderInstance = this;
		this.button = document.getElementById(options.buttonLink);
		this.imgPlay = document.getElementById(options.playButton);
		this.imgPause = document.getElementById(options.pauseButton);
		this.turnOnTooltip = options.turnOnTooltip;
		this.turnOffTooltip = options.turnOffTooltip;
		this.url = this.button.href;
		this.button.href = '#?';
		this.isAndroid = navigator.userAgent.match(/droid/i) != null;
		this.safeObserve(this.button, 'click', this.onClick.bind(this));
		this.showCorrectImage();
	}

	onClick(ev) {
		ev.preventDefault();

		axios(this.url, {
			method: 'get'
		}).then(this.onSuccess.bind(this));
	}

	onSuccess(ev) {
		if (GamesTextToSpeechInstance !== null && GamesTextToSpeechInstance !== undefined) {
			if (GamesTextToSpeechInstance.isEnabled) {
				GamesTextToSpeechInstance.turnOffTextToSpeech();
			} else {
				GamesTextToSpeechInstance.turnOnTextToSpeech();
				GamesQuizInstance.createAndReadAllTextToSpeech();
			}
			this.showCorrectImage();
		}
	}

	showCorrectImage() {
		if (GamesTextToSpeechInstance !== null && GamesTextToSpeechInstance !== undefined) {
			if (GamesTextToSpeechInstance.isEnabled) {
				this.imgPlay.style.display = 'none';
				this.imgPause.style.display = 'block';
				this.button.title = this.turnOffTooltip;
			} else {
				GamesTextToSpeechInstance.removeTextToSpeechEffects();
				this.imgPlay.style.display = 'block';
				this.imgPause.style.display = 'none';
				this.button.title = this.turnOnTooltip;
			}
		}
	}
}
